import { ACTION_CLICK_AVATAR_CARD_LINK } from 'utils/analytics/eventTypeConstantsAmplitude';
import { BaseWidgetProps } from 'consumer-page-widgets/WidgetUtils/BaseWidgetProps';
import { ValidForRowLayoutWidgetProps } from 'consumer-page-widgets/RowLayoutWidget/RowLayoutWidget';
import { consumer } from '@tock/coretypes';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { wrapWithWidgetContainer } from 'consumer-page-widgets/WidgetUtils/widgetDisplayUtils';
import AvatarCardLink from 'consumer-page-widgets/AvatarCardLinkWidget/AvatarCardLink';
import React from 'react';

interface AvatarCardLinkWidgetProps extends BaseWidgetProps, ValidForRowLayoutWidgetProps {
  widget: consumer.IAvatarCardLinkWidget;
}

const AvatarCardLinkWidget: React.FunctionComponent<AvatarCardLinkWidgetProps> = ({
  widget,
  standalone = true,
  pageWidgetListIndex,
}) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const onClick = () => {
    amplitudeSendEvent(ACTION_CLICK_AVATAR_CARD_LINK, {
      pageWidgetListIndex,
      title: widget.title ?? undefined,
      widgetType: 'Avatar collection card link widget',
      destinationHref: widget.linkHref ?? undefined,
    });
  };

  const avatarCardLink = (
    <AvatarCardLink
      imageAlt={widget.imageAlt ?? ''}
      imageUrl={widget.imageUrl ?? ''}
      title={widget.title ?? ''}
      subtitle={widget.subtitle ?? ''}
      linkHref={widget.linkHref ?? ''}
      linkText={widget.linkText ?? ''}
      onClick={onClick}
    />
  );

  return standalone ? wrapWithWidgetContainer(avatarCardLink) : avatarCardLink;
};

export default AvatarCardLinkWidget;
